export interface BoothSetting {
  name: string;
  setupTime: number;
  breakdownTime: number;
}

export interface SavedLocation {
  id: string;
  name: string;
  address: string;
  createdAt: number;
}

export interface UserSettings {
  booths: { [key: string]: BoothSetting };
  theme: 'light' | 'dark';
  backgroundColor: string;
  savedLocations: SavedLocation[];
}

export const defaultBoothSettings: { [key: string]: BoothSetting } = {
  inflatable: {
    name: "Inflatabe Booth",
    setupTime: 45,
    breakdownTime: 30,
  },
  backdrop: {
    name: "Backdrop Booth",
    setupTime: 60,
    breakdownTime: 35,
  },
  solo: {
    name: "Solo Selfie Cube",
    setupTime: 45,
    breakdownTime: 25,
  },
  '360': {
    name: "360",
    setupTime: 45,
    breakdownTime: 30,
  },
};

export const config = {
  // The Google Maps API key is injected at build-time from an environment
  // variable. Create a file named `.env.local` (ignored by Git) in the project
  // root and add a line such as:
  //   REACT_APP_GOOGLE_MAPS_API_KEY=your-key-here
  // For CI / production, you can instead set this variable in the environment
  // before running `npm run build`.
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  takedownTime: 30, // in minutes - kept for backward compatibility
  setupTimes: {
    inflatable: 45,
    backdrop: 60,
    solo: 45,
    '360': 45,
  },
};

// User settings management
const SETTINGS_KEY = 'willTheyMakeIt_userSettings';

export const loadUserSettings = (): UserSettings => {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        booths: { ...defaultBoothSettings, ...parsed.booths },
        theme: parsed.theme || 'light',
        backgroundColor: parsed.backgroundColor || '#ffffff',
        savedLocations: parsed.savedLocations || [],
      };
    }
  } catch (error) {
    console.error('Error loading user settings:', error);
  }
  
  return {
    booths: { ...defaultBoothSettings },
    theme: 'light',
    backgroundColor: '#ffffff',
    savedLocations: [],
  };
};

export const saveUserSettings = (settings: UserSettings): void => {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving user settings:', error);
  }
};

export const resetUserSettings = (): UserSettings => {
  const defaultSettings = {
    booths: { ...defaultBoothSettings },
    theme: 'light' as const,
    backgroundColor: '#ffffff',
    savedLocations: [],
  };
  saveUserSettings(defaultSettings);
  return defaultSettings;
}; 